import { useMemo } from "react";

import { useAtom } from "jotai";
import { orderBy } from "lodash";

import { ClientKpisAtom, useGlobalMMMStore } from "../mmm-provider";

export const useClientKpis = () => {
  const GlobalMMMStore = useGlobalMMMStore();

  const [clientKpis, setClientKpis] = useAtom(ClientKpisAtom, {
    store: GlobalMMMStore,
  });

  const orderedKpis = useMemo(() => {
    return orderBy(clientKpis, "friendly_name");
  }, [clientKpis]);

  return {
    kpis: orderedKpis,
    setClientKpis,
  };
};
